import Keycloak from 'keycloak-js';

const requiredVariables = [
  'REACT_APP_KEYCLOAK_URL',
  'REACT_APP_KEYCLOAK_REALM',
  'REACT_APP_KEYCLOAK_CLIENT_ID',
];

for (const variableName of requiredVariables) {
  if (!process.env[variableName]) {
    throw new Error(`Missing environment variable: ${variableName}`);
  }
}

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export default keycloak;